import {Meta, Links, PaginatedQueryParams} from './apiTypes';

export type TicketStatus = 'new' | 'in progress' | 'resolved' | 'archived';

export const ticketTypes = ['member', 'ticket type 2', 'ticket type 3', 'ticket type 4'] as const;
export const ticketContexts = ['applications', 'business', 'ticket context 3', 'ticket context 4'] as const;

export type TicketType = (typeof ticketTypes)[number];
export type TicketContext = (typeof ticketContexts)[number];

export interface Ticket {
    id: number;
    account_number: string;
    body: string;
    context: TicketContext[];
    created_at: string;
    created_by: string;
    regarding: string;
    status: TicketStatus;
    ticket_number: number;
    type: TicketType[];
}

export interface TicketsData {
    data: Ticket[];
    links: Links[];
    meta: Meta;
}

export interface UpdateTicketParams {
    ticketID: number;
    ticketData: { status: TicketStatus };
}

export interface AccountNumberLinkProps {
    accountNumber: string | null;
}

export interface GetTicketsParams extends PaginatedQueryParams {
    filters?: FilterQueryParams;
}

export interface FilterOptions {
    types: string[];
    contexts: string[];
    statuses: string[];
}

const typeColors = ['geekblue', 'green', 'cyan', 'orange'];
const contextColors = ['geekblue', 'magenta', 'purple', 'gold'];

export const ticketStatusColors: Record<TicketStatus, string> = {
    new: '#1890FF',
    'in progress': '#FAAD14',
    resolved: '#52C41A',
    archived: '#D9D9D9',
};

export interface TicketDetails {
    name: string;
    color: string;
}

export const ticketTypeMap: Record<string, TicketDetails> = {
    [ticketTypes[0]]: {
        name: ticketTypes[0],
        color: typeColors[0],
    },
    [ticketTypes[1]]: {
        name: ticketTypes[1],
        color: typeColors[1],
    },
    [ticketTypes[2]]: {
        name: ticketTypes[2],
        color: typeColors[2],
    },
    [ticketTypes[3]]: {
        name: ticketTypes[3],
        color: typeColors[3],
    },
};

export const ticketContextMap: Record<string, TicketDetails> = {
    [ticketContexts[0]]: {
        name: ticketContexts[0],
        color: contextColors[0],
    },
    [ticketContexts[1]]: {
        name: ticketContexts[1],
        color: contextColors[1],
    },
    [ticketContexts[2]]: {
        name: ticketContexts[2],
        color: contextColors[2],
    },
    [ticketContexts[3]]: {
        name: ticketContexts[3],
        color: contextColors[3],
    },
};

export interface SelectedStatuses {
    [ticketNumber: number]: TicketStatus;
}

export interface FilterQueryParams {
    type?: string;
    context?: string;
    status?: string;
    account_membership_number?: string;
    regarding_first_name?: string;
    regarding_last_name?: string;
}

export interface TicketFilterProps {
    onSearch: (values: FilterQueryParams) => void;
    onReset: () => void;
}

export interface TicketCommentsDrawerProps {
    ticket: Ticket
    drawerOpen: boolean
    handleClose: () => void;
}
